import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import EcoMode from '../lib/EcoMode';

import { USER_PREFERENCES_UPDATED } from '../lib/events';
import { loadFlickity } from '../lib/async-bundles';

export default (el, props) => {
    const $el = $(el);

    const $slideWrapper = $el.find('[data-promotion-slide-wrapper]');
    const $slides = $el.find('[data-promotion-slide]');
    const $buttons = $el.find('[data-promotion-slide-target]');

    let Flickity = null;
    let slideshow = null;
    let lastW = 0;

    const init = () => {
        if (EcoMode.shouldAnimate()) {
            loadBundles();
        }

        $el.on('click', '[data-promotion-slide-target]', e => {
            e.preventDefault();
            const $target = $(e.triggerTarget);
            const num = $target.attr('data-promotion-slide-target');

            showSlide(num);
        });

        Viewport.on('resize', onResize);
        Dispatch.on(USER_PREFERENCES_UPDATED, onUserPreferencesUpdated);
    };

    const destroy = () => {
        $el.off('click');
        destroyFlickity();
        Viewport.off('resize', onResize);
        Dispatch.off(USER_PREFERENCES_UPDATED, onUserPreferencesUpdated);
    };

    const onUserPreferencesUpdated = () => {
        if (EcoMode.shouldAnimate()) {
            if (Flickity === null) {
                loadBundles();
            }
        } else {
            if (slideshow !== null) {
                destroyFlickity();
            }
            
            Flickity = null;
        }
    };
 
    const onResize = () => {
        if (lastW !== Viewport.width) {
            if (Flickity) { 
                initFlickity();
            }

            lastW = Viewport.width;
        }
    };
    
    const loadBundles = () => {
        if (Flickity === null) {
            loadFlickity(flickity => {
                Flickity = flickity;
                // gsap.defaults({ overwrite: 'auto' });
    
                initFlickity();
            });
        }
    };

    const setButtons = activeNum => {
        $buttons.removeClass('selected');
        $buttons.eq(parseInt(activeNum, 10)).addClass('selected');
    };

    const showSlide = activeNum => {
        if (slideshow) {
            slideshow.selectCell(parseInt(activeNum, 10));
        } else {
            const $slide = $slides.eq(parseInt(activeNum, 10));
            
            if ($slide.length > 0) {
                $slides.css({ display: 'none' });
                $slide.css({ display: null });
            }
        }
        
        setButtons(activeNum);
    };

    const initFlickity = () => {
        destroyFlickity();

        $el.addClass('js-has-flickity');

        $slideWrapper.css({ display: 'block' });
        $slides.css({ display: 'grid' });
        
        let maxHeight = 0;
        
        $slides.each(item => {
            const $item = $(item);
            maxHeight = Math.max(maxHeight, $item.height());
        });

        $slideWrapper.css({ height: `${maxHeight}px` });
        $slides.css({ height: `${maxHeight}px` });
        
        slideshow = new Flickity($slideWrapper.get(0), {
            pageDots: false,
            prevNextButtons: false,
            setGallerySize: false,
            resize: false,
            wrapAround: true,
            freeScroll: false,
            groupCells: false,
            cellAlign: 'left',
            contain: true,
            autoPlay: 7000,
            accessibility: false
        });

        slideshow.on('dragStart', () => slideshow.slider.childNodes.forEach(slide => {
            slide.style.pointerEvents = 'none';
        }));

        slideshow.on('dragEnd', () => slideshow.slider.childNodes.forEach(slide => {
            slide.style.pointerEvents = 'all';
        }));

        slideshow.on('select', (index) => {
            setButtons(index);
        });
        
        setButtons(0);
    };


    const destroyFlickity = () => {
        if (!slideshow) {
            return;
        }

        slideshow.destroy();
        slideshow = null;

        $slideWrapper.attr('style', '');
        $slides.attr('style', '');

        $el.removeClass('js-has-flickity');
        
        showSlide(0);
    };
    
    return {
        init,
        destroy
    };

};
